import { Chip } from '@mui/material';

import { GenericRefModel } from '../../Models/CommonModel';

type GenericPropertyInputRefContentProps = {
	value: GenericRefModel | undefined;
	icon?: React.ReactNode;
};

export default function GenericPropertyInputRefContent({ value, icon }: GenericPropertyInputRefContentProps) {
	if (!value) {
		return null;
	}

	return (
		<Chip
			icon={icon ? <>{icon}</> : undefined}
			label={value.Name ?? value.Id}
			size="small"
			variant="outlined"
			color="primary"
			sx={{
				maxWidth: '100%',
				p: 2,
				alignItems: 'center',
				'& .MuiChip-icon': {
					display: 'flex',
				},
				'& .MuiChip-label': {
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
				},
			}}
		/>
	);
}
